import React, { useEffect } from "react";
import { Button, Card, Dropdown, Space, message } from "antd";
import { useState } from "react";
import { TabOnboarding } from "./TabOnboarding";
import { DatosPersonales } from "./DatosPersonales";
import { ModalRechazarOnboarding } from "components/Modal/ModalRechazarOnboarding";
import { UserAddOutlined, EllipsisOutlined, MailOutlined } from "@ant-design/icons";
import { useAtom } from "jotai";
import { colaboradorAtom, visibleModalActivarColaboradorAtom } from "../../LegajoColaboradorStore";
import { ContratosTab } from "./ContatosTab";
import { LegajoTab } from "./LegajoTab";
import { OnboardingIngresoColaboradorService } from "services/OnboardingIngresoColaboradorService";
import UsuarioService from "services/UsuarioService";
import { OPCIONES } from "enums";

const CardDocumentosColaborador = () => {

    const [activeTabKey, setActiveTabKey] = useState("datosPersonales");
    const [opciones, setOpciones] = useState([]);

    useEffect(() => {
        const cargarDatos = async () => {
            const opciones = await UsuarioService.listarOpciones();
            setOpciones(opciones);
            if (opciones.includes(OPCIONES.PAGINA_MANTENIMIENTO_COLABORADOR.OCULTAR_TAB_DATOS_PERSONALES)) {
                setActiveTabKey("onboarding");
            }
        }

        cargarDatos();
    }, []);

    const tienePermisoContratos = opciones.includes("mantenimiento.colaborador.tab.contratos");
    const tieneOcultoTabDatosPersonales = opciones.includes(
        OPCIONES.PAGINA_MANTENIMIENTO_COLABORADOR.OCULTAR_TAB_DATOS_PERSONALES
    );

    const tabs = [
        ...(tieneOcultoTabDatosPersonales ? [] : [{
            key: "datosPersonales",
            tab: "Datos Personales",
        }]),
        {
            key: "onboarding",
            tab: "Onboarding",
        },
        ...(tienePermisoContratos ? [{
            key: "contratos",
            tab: "Contratos",
        }] : []),
        {
            key: "legajos",
            tab: "Legajo",
        },
    ];

    const listaTabs = {
        datosPersonales: <DatosPersonales />,
        onboarding: <TabOnboarding />,
        contratos: <ContratosTab />,
        legajos: <LegajoTab />,
    };

    const onTabChange = (key) => {
        setActiveTabKey(key);
    };

    return (
        <div className="lista-documentos">
            <Card
                tabList={tabs}
                activeTabKey={activeTabKey}
                onTabChange={(key) => {
                    onTabChange(key);
                }}
                tabBarExtraContent={<BotonesExtra tab={activeTabKey} />}
                style={{ marginBottom: "30px" }}
            >
                {listaTabs[activeTabKey]}
            </Card>
            <ModalRechazarOnboarding />
        </div>
    );
};

const BotonesExtra = ({ tab }) => {
    const [, setVisibleModalActivarColaborador] = useAtom(visibleModalActivarColaboradorAtom);
    const [colaboradorSeleccionado] = useAtom(colaboradorAtom);

    const items = [];
    if (colaboradorSeleccionado?.estadoRegistro !== "ACTIVO") {
        items.push({
            key: "activar-postulante",
            label: (
                <Space>
                    <UserAddOutlined />
                    Activar Postulante
                </Space>
            ),
        });
    }

    items.push({
        key: "reenviar-notificacion-onboarding",
        label: (
            <Space>
                <MailOutlined />
                Reenviar Notificación Onboarding
            </Space>
        ),
    });

    const onClickItem = (e) => {
        if (e.key === "activar-postulante") {
            setVisibleModalActivarColaborador(true);
        } else if (e.key === "reenviar-notificacion-onboarding") {
            OnboardingIngresoColaboradorService.reenviarNotificacionOnboarding(colaboradorSeleccionado.numeroDocumentoIdentidad);
            message.success("Notificación reenviada.")
        }
    };

    return (
        <Dropdown
            menu={{
                items,
                onClick: onClickItem,
            }}
            trigger={["click"]}
            placement="bottomRight"
            arrow
        >
            <Button type="link">
                <EllipsisOutlined style={{ fontSize: "24px", color: "#6d6e6f" }} />
            </Button>
        </Dropdown>
    );
};

export default CardDocumentosColaborador;
